export default "__VITE_ASSET__eRaXreAM__"